import module from 'recursoshumanos/module.js'

export class RecursoshumanosComparativasuanominaReporteService {
  constructor ($http) {
    this.$http = $http
  }

  get (empresaId, periodo, mes) {
    return this.$http.get(`/api/recursos_humanos/comparativa_sua_nomina/reporte`, {
      params: {
        empresa_id: empresaId,
        mes: mes,
        periodo: periodo,
      },
      download: true,
    })
  }
}

module.service('RecursoshumanosComparativasuanominaReporteService', RecursoshumanosComparativasuanominaReporteService)



// WEBPACK FOOTER //
// ./src/recursoshumanos/services/RecursosHumanos/Comparativasuanomina/Reporte.js